module.exports = __webpack_public_path__ + "img/36.4fac3c8d.jpg";